import BotoesSalvarExcluir from '@/shared/components/forms/BotoesSalvarExcluir';
import Links from '@/shared/constants/navegacao';
import ModalExcluir from '@/shared/components/modals/ModalExcluir';
import ModalHistorico from '@/modules/system/historico/ModalHistorico';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';
import { EditadoPorRodape } from '@/shared/components/EditadoPorRodape';
import { useNavigate } from 'react-router-dom';
import { ReadAtuacaoDto, CreateAtuacaoDto } from '@/api.types';
import { SubmitHandler, useForm } from 'react-hook-form';
import { Tabelas } from '@/shared/constants/tables';
import { createAtuacao, deleteAtuacao, readAtuacao, updateAtuacao } from './atuacao.service';
import { toast } from 'react-toastify';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

export default function AtuacoesEditPage() {
  const { setActions } = useBreadcrumbActions();
  const navigate = useNavigate();
  const params = useParams();

  const { register, handleSubmit, reset, getValues } = useForm<ReadAtuacaoDto>();

  const [modaExcluirShow, setModalExcluirShow] = useState(false);
  const [modalHistorico, setModalHistorico] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const id = params.id ? Number(params.id) : 0;
  const btnSalvar = id > 0 ? 'Salvar' : 'Cadastrar';

  useEffect(() => {
    setActions({
      secondary: { label: 'Novo', href: Links.Atuacoes_Criar, onClick: () => { } },
      history: { label: 'Histórico', onClick: () => setModalHistorico(true) },
    });
    return () => setActions({});
  }, [setActions]);

  useEffect(() => {
    if (id > 0) {

      readAtuacao({ id: id, take: 1 })
        .then((res) => {
          if (res) {
            reset(res[0].shift());
          }
        })
        .catch((res) => {
          toast.error(String(res));
        })
    }
  }, []);

  const onSubmit: SubmitHandler<CreateAtuacaoDto> = (data) => {

    if (id > 0) {
      updateAtuacao(data)
        .then(() => {
          toast.success("Atuação Atualizada.");
          navigate(`${Links.Atuacoes_Index}`);
        })
        .catch((res) => {
          toast.error(String(res));
        })
        .finally(() => setIsLoading(false));
    } else {
      createAtuacao(data)
        .then(() => {
          toast.success("Atuação Cadastrada.");
          navigate(`${Links.Atuacoes_Index}`);
        })
        .catch((res) => {
          toast.error(String(res));
        })
        .finally(() => setIsLoading(false));
    }
  };

  const handleExcluir = async (e: any) => {
    e.preventDefault();

    setModalExcluirShow(false);
    deleteAtuacao(id)
      .then(() => {
        toast.warning("Atuação Removida.");
        navigate(`${Links.Atuacoes_Index}`);
      })
      .catch((res) => {
        toast.error(String(res));
      });
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <h3>Atuação</h3>
        </div>
      </div>
      <hr className="pb-4" />

      <form onSubmit={(event) => { void handleSubmit(onSubmit)(event) }} >
        <div className="row">
          <div className="mb-3 col-md-2">
            <label htmlFor="ordem" className="form-label">
              Ordem:
            </label>
            <input autoFocus={true} title="Ordem" type="number" className="form-control" min={0} {...register('ordem')} />
          </div>

          <div className="mb-3 col-md-5">
            <label htmlFor="nome" className="form-label">
              Nome:
            </label>
            <input autoFocus={true} title="Nome" type="text" className="form-control" {...register('nome')} />
          </div>

          <EditadoPorRodape dados={getValues()} />

          <div>
            <BotoesSalvarExcluir
              isLoading={isLoading}
              texto={btnSalvar}
              textoLoading={btnSalvar === 'Cadastrar' ? ' Cadastrando...' : ' Salvando...'}
              id={id}
              onExcluirClick={() => setModalExcluirShow(true)}
            />
          </div>
        </div>
      </form>

      <ModalExcluir
        show={modaExcluirShow}
        handleExcluir={handleExcluir}
        handleHide={() => setModalExcluirShow(false)}
      ></ModalExcluir>
      <ModalHistorico
        show={modalHistorico}
        handleHide={() => setModalHistorico(false)}
        tabela={Tabelas.atuacao}
        idRegistro={id}
      ></ModalHistorico>
    </>
  );
}
